import { OptimizePlanSignalRMessageRequest } from "./optimize-plan-signalR-message-request";

export interface OptimizePlanSignalRResultRequest {
    connectionId: string;
    message: OptimizePlanSignalRMessageRequest;
}